import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';


interface BreadcrumbItem {
    label: string;
    href?: string;
}

interface BreadcrumbProps {
    items: BreadcrumbItem[];
}

/**
 * Breadcrumb navigation component for SEO and user navigation.
 * Renders: NSW > [Location] > [Gym Name]
 */
const Breadcrumb: React.FC<BreadcrumbProps> = ({ items }) => {
    return (
        <nav aria-label="Breadcrumb" className="mb-4">
            <ol className="flex flex-nowrap items-center gap-1.5 text-sm text-text-muted">
                {items.map((item, index) => (
                    // Trail items never shrink; the current-page item (no href) gets min-w-0 so
                    // its label truncates to fit the remaining width instead of wrapping/cramming.
                    <li key={index} className={`flex items-center ${item.href ? 'shrink-0' : 'min-w-0'}`}>
                        {index > 0 && (
                            <ChevronRight size={14} className="mx-1.5 text-text-muted" />
                        )}
                        {item.href ? (
                            <Link
                                to={item.href}
                                className="hover:text-brand-primary hover:underline transition-colors"
                            >
                                {item.label}
                            </Link>
                        ) : (
                            <span aria-current="page" className="text-text-primary font-medium truncate max-w-[200px]">
                                {item.label}
                            </span>
                        )}
                    </li>
                ))}
            </ol>
        </nav>
    );
};

export type { BreadcrumbItem };
export default Breadcrumb;
